// frontend/src/pages/PassportPage.tsx
import { useState } from 'react';
import { useAppNavigate } from '../contexts/PwaNavContext';
import { useCustomerAuth } from '../contexts/CustomerAuthContext';
import FoodPassportPanel from '../components/FoodPassportPanel';
import FirebaseAuthModal from '../components/FirebaseAuthModal';
import type { Customer } from '../contexts/CustomerAuthContext';
import './PassportPage.css';

export default function PassportPage() {
  const { isAuthenticated } = useCustomerAuth();
  const navigate = useAppNavigate();
  const [showAuth, setShowAuth] = useState(false);
  const [justLoggedIn, setJustLoggedIn] = useState<{ customer: Customer; token: string } | null>(null);

  return (
    <>
      <FoodPassportPanel
        key={isAuthenticated || justLoggedIn ? 'auth' : 'guest'}
        justLoggedIn={justLoggedIn}
        standalone={true}
        onBackToOrder={() => navigate('/')}
        onShowAuth={() => setShowAuth(true)}
      />
      {showAuth && (
        <FirebaseAuthModal
          onClose={() => setShowAuth(false)}
          onSuccess={(customer, token, _newBadges) => {
            setJustLoggedIn({ customer, token });
            setShowAuth(false);
            // newBadges handled by FoodPassportPanel via justLoggedIn prop
          }}
        />
      )}
    </>
  );
}
